// Wire protocol shared by the browser client and the Cloudflare Worker / Durable Object.
export const PROTOCOL = 1;
export const POSE_HZ = 10;             // client → server pose rate
export const STATE_HZ = 8;             // server → clients pose broadcast (only while ≥2 players)
export const DMG_BATCH_MS = 100;
export const MAX_PLAYERS = 12;
export const NAME_MAX = 14;
export const HAMMER_CD_MS = 20000, HAMMER_R = 50, HAMMER_DMG_R = 120;   // World mode: tighter than solo (70 m / 15 s) so one giant can't level a block alone
export const GEM_N = 16, GEM_RESPAWN_MS = 18000, GEM_PICK_R = 30, GEM_JUICE = 30;
export const CRUSH_R = 34;             // a player may crush a building only this close to their reported position
export const CRUSH_MAX_H = 34;         // and only if it is under a third of the giant's height
export const DPS_CAP_BUILDING = 4.5;   // per player, per building, per second (beam max 3.2 + splash)
export const DPS_CAP_TOTAL = 30;       // per player, per second, all buildings
export const CHAIN_WINDOW_MS = 3000, CHAIN_STEP = 0.25, CHAIN_MAX = 3;
export const CITY_TZ: Record<string, string> = { brickell: 'America/New_York', midtown: 'America/New_York', loop: 'America/Chicago', fidi: 'America/Los_Angeles', cityldn: 'Europe/London', shibuya: 'Asia/Tokyo' };

export type BId = string;
export interface Pose { p: [number, number]; yaw: number; pitch: number; aim: [number, number, number]; fire: 0 | 1; w: number }
export interface PlayerPub { id: string; name: string; pose: Pose; dollars: number }
export interface GemPub { id: number; p: [number, number] | null }

export type ClientMsg =
  | { t: 'hello'; v: number; pid: string; name: string }
  | ({ t: 's' } & Pose)
  | { t: 'dmg'; hits: Array<[BId, number]> }
  | { t: 'hammer'; p: [number, number] }
  | { t: 'crush'; b: BId }
  | { t: 'gem'; id: number }
  | { t: 'ping'; n: number };

export type ServerMsg =
  | { t: 'snap'; day: string; resetAt: number; standing: number; totalValue: number; destroyed: BId[]; hp: Record<BId, number>; gems: GemPub[]; players: PlayerPub[]; you: string }
  | { t: 'S'; players: PlayerPub[]; now: number }
  | { t: 'destroyed'; b: BId; by: string; value: number; mult: number }
  | { t: 'hp'; b: BId; hp: number }
  | { t: 'gem'; id: number; p: [number, number] | null; by?: string }
  | { t: 'hammer'; p: [number, number]; by: string }
  | { t: 'join'; player: PlayerPub }
  | { t: 'leave'; id: string }
  | { t: 'score'; id: string; dollars: number }
  | { t: 'reset'; day: string; resetAt: number }
  | { t: 'full' } | { t: 'kick'; why: string } | { t: 'pong'; n: number; now: number };

export function cleanName(raw: string): string {
  const s = (raw || '').replace(/[^\w \-.']/g, '').trim().slice(0, NAME_MAX);
  if (!s) return 'GIANT';
  return BAD.some(w => s.toLowerCase().includes(w)) ? 'GIANT' : s;
}
const BAD = ['fuck', 'shit', 'cunt', 'nigg', 'fag', 'bitch', 'rape', 'nazi', 'hitler', 'kike', 'spic', 'chink', 'retard'];
